module.exports = __webpack_public_path__ + "img/search-grey.41e5bfa3.svg";